import { graphql } from "gatsby"
import React from "react"
import Default from "../components/layout/Default"
import Header from "../components/header/Header"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import Introduction from "./introduction"
import Contact from "./contact"

export const query = graphql`
  query {
    fileName: file(relativePath: { eq: "avatar.jpeg" }) {
      childImageSharp {
        fixed(width: 100, height: 100) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`
const BASE_PATH = "dragosnedelcu@md-pc"

export default function Home({ data }) {
  return (
    <Default title="Home">
      <Header data={data} />
      <div className="container">
        <div
          className="coding inverse-toggle px-5 pt-4 shadow-xl text-gray-100 text-sm font-mono subpixel-antialiased h-2/3 md:h-96 mb-5
            bg-gray-800  pb-6 rounded-lg leading-normal overflow-hidden"
        >
          <Tabs selectedTabClassName="border-primary-500 border-opacity-1">
            <div className="top mb-2 flex">
              <div className="h-3 w-3 bg-red-500 rounded-full"></div>
              <div className="ml-2 h-3 w-3 bg-orange-300 rounded-full"></div>
              <div className="ml-2 h-3 w-3 bg-green-500 rounded-full"></div>
            </div>
            <TabList>
              <div className="flex flex-wrap">
                <Tab className="px-8 py-2 text-center cursor-pointer border-b-2 border-gray-800">
                  {BASE_PATH}: ~/introduction
                </Tab>
                <Tab className="px-8 py-2 text-center cursor-pointer border-b-2 border-gray-800">
                  {BASE_PATH}: ~/contact
                </Tab>
              </div>
            </TabList>
            <TabPanel>
              <Introduction />
            </TabPanel>
            <TabPanel>
              <Contact />
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </Default>
  )
}
